import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import useLenis from "@/hooks/useLenis";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartDrawer } from "@/components/CartDrawer";
import { Nav } from "@/components/Nav";
import { AnnouncementBar } from "@/components/AnnouncementBar";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import PrintDetail from "@/pages/PrintDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const PAYPAL_OPTIONS = {
  "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
  currency: "USD",
  intent: "capture",
};

function ProtectedRoute({ children }) {
  const { token, checking } = useAuth();
  if (checking) return <div className="min-h-screen flex items-center justify-center label text-stone">Loading…</div>;
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <AnnouncementBar />}
      {!isAdmin && <Nav />}
      {!isAdmin && <CartDrawer />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery/:slug" element={<Gallery />} />
        <Route path="/print/:id" element={<PrintDetail />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

function App() {
  useLenis();
  return (
    <div className="App grain">
      <AuthProvider>
        <CartProvider>
          <PayPalScriptProvider options={PAYPAL_OPTIONS}>
            <BrowserRouter>
              <Shell />
            </BrowserRouter>
          </PayPalScriptProvider>
          <Toaster position="bottom-right" theme="dark" />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
